import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import '@/App.css';

// Code-split the heavy authenticated pages. Each route now loads its own
// chunk on demand, so the initial bundle (Login + framework) ships fast.
const Dashboard           = lazy(() => import('./pages/Dashboard'));
const Orders              = lazy(() => import('./pages/Orders'));
const OrderDetail         = lazy(() => import('./pages/OrderDetail'));
const CreateOrder         = lazy(() => import('./pages/CreateOrder'));
const ActivityLogs        = lazy(() => import('./pages/ActivityLogs'));
const Users               = lazy(() => import('./pages/Users'));
const Notifications       = lazy(() => import('./pages/Notifications'));
const Dissertations       = lazy(() => import('./pages/Dissertations'));
const CreateDissertation  = lazy(() => import('./pages/CreateDissertation'));
const DissertationDetail  = lazy(() => import('./pages/DissertationDetail'));
const Analytics           = lazy(() => import('./pages/Analytics'));
const PublicShareOrder    = lazy(() => import('./pages/PublicShareOrder'));

// Lightweight chunk-load fallback that matches the app's emerald theme.
const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-emerald-50/40">
    <div className="flex items-center gap-2 text-emerald-700 text-sm">
      <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
      <span>Loading…</span>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/orders/:token" element={<PublicShareOrder />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/orders/:orderId" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
            <Route path="/orders/new" element={<ProtectedRoute><CreateOrder /></ProtectedRoute>} />
            <Route path="/activity-logs" element={<ProtectedRoute><ActivityLogs /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/dissertations" element={<ProtectedRoute><Dissertations /></ProtectedRoute>} />
            <Route path="/dissertations/new" element={<ProtectedRoute><CreateDissertation /></ProtectedRoute>} />
            <Route path="/dissertations/:id" element={<ProtectedRoute><DissertationDetail /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
